<script setup lang="ts">
defineProps<{
  show: boolean;
}>();
const emit = defineEmits<(e: "close") => void>();
function close() {
  emit("close");
}
</script>
<template>
  <Teleport to="#modals-portal">
    <transition name="modal">
      <div v-if="show" class="modal-mask">
        <div v-click-away="close" class="modal-wrapper">
          <div class="modal-container tw-overflow-auto">
            <div class="modal-header tw-flex tw-justify-between tw-p-3 tw-leading-6">
              <slot name="modal-title"> default header </slot>
              <button title="Close Modal" @click="close">
                <i class="fa fa-times" />
              </button>
            </div>
            <div class="modal-body tw-h-full tw-overflow-auto tw-p-3">
              <slot> default body </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 19998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  overflow: auto;
}

.modal-wrapper {
  position: relative;
  width: auto;
  margin: 1.75rem auto;
  max-width: 500px;
}

.modal-container {
  width: 100%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
